import { render, staticRenderFns } from "./agentEntrustList.vue?vue&type=template&id=5ccdb6f5"
import script from "./agentEntrustList.vue?vue&type=script&lang=js"
export * from "./agentEntrustList.vue?vue&type=script&lang=js"
import style0 from "./agentEntrustList.vue?vue&type=style&index=0&id=5ccdb6f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports